//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObjectCollection.js";
import "../no/BasePart.js";
let d=[[],[[["selectionObject"],"CreateSelectionProgramMainBuilder",{R_:{builder:"Features.SelectionProgramMainBuilder"}},1,0],[[],"CreateSelectionProgramListItemBuilder",{R_:{selectionObject:"Features.SelectionProgramListItemBuilder"}},0,0],[[],"CreateSelectionProgramClosestBuilder",{R_:{builder:"Features.SelectionProgramClosestBuilder"}},0,0],[[],"CreateSelectionProgramFarthestBuilder",{R_:{builder:"Features.SelectionProgramFarthestBuilder"}},0,0],[[],"CreateSelectionProgramBetweenBuilder",{R_:{builder:"Features.SelectionProgramBetweenBuilder"}},0,0],[[],"CreateSelectionProgramDirectionFromBuilder",{R_:{builder:"Features.SelectionProgramDirectionFromBuilder"}},0,0],[[],"CreateSelectionProgramPiercedByBuilder",{R_:{builder:"Features.SelectionProgramPiercedByBuilder"}},0,0],[[],"CreateSelectionProgramIntersectedByBuilder",{R_:{builder:"Features.SelectionProgramIntersectedByBuilder"}},0,0],[[],"CreateSelectionProgramAdjacentBuilder",{R_:{builder:"Features.SelectionProgramAdjacentBuilder"}},0,0],[[],"CreateSelectionProgramFeatureBuilder",{R_:{builder:"Features.SelectionProgramFeatureBuilder"}},0,0],[[],"CreateSelectionProgramInsideBodyBuilder",{R_:{builder:"Features.SelectionProgramInsideBodyBuilder"}},0,0],[[],"CreateSelectionProgramObjectTypeBuilder",{R_:{builder:"Features.SelectionProgramObjectTypeBuilder"}},0,0],[[],"CreateSelectionProgramRegionFacesBuilder",{R_:{builder:"Features.SelectionProgramRegionFacesBuilder"}},0,0]],[]];
SPLM.Features.SelectionProgramCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.SelectionProgramCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;